import * as React from 'react';

import { Text } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
import type { AudiFinalFootnotesToRenderInterface } from './audi-footnote-engine';

interface AudiFootnoteListItemProps {
  footnoteItem: AudiFinalFootnotesToRenderInterface;
  footnoteIndex?: string;
  referenceID?: string | null;
}

const FootnoteStyledListItem = styled.li`
  padding-bottom: 16px;
  &:last-child {
    padding-bottom: 0;
  }
  .flex {
    display: flex;
    gap: 10px;
  }
  a {
    color: inherit;
    font-weight: 700;
  }
`;

const sanitizeHtml = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const scripts = doc.querySelectorAll('script');

  scripts.forEach((script) => {
    if (script.parentNode) {
      const illegalscript = document.createTextNode('illegalscript');
      script.parentNode.replaceChild(illegalscript, script);
    }
  });

  return doc.body.innerHTML;
};

const AudiFootnoteListItem: React.FC<AudiFootnoteListItemProps> = ({
  footnoteItem,
  footnoteIndex,
  referenceID,
}) => {
  // We use a native <a> tag as a string so it can be safely concatenated with footnoteItem.Text
  // for use inside dangerouslySetInnerHTML. JSX or React components won't work in this case.
  const backIconLink = referenceID
    ? `
    <a aria-label='back to page content footnote ${footnoteIndex}' href='#${referenceID}' style='position: relative; top: -1px; padding-left: 4px; vertical-align: middle; display: inline-flex;'>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="16px" height="16px" class="sc-dLMFU dRfvgU">
        <g id="main"><path fill="currentColor" d="m.3 5.5 3.72-1.85v1.36H15V12H8v-1h6V6H4.02v1.37z"/></g>
      </svg>
    </a>`
    : '';

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <FootnoteStyledListItem id={footnoteItem.contextID} tabIndex="-1">
      <Text variant={{ type: 'copy', order: '2', style: 'normal' }} className="flex">
        {footnoteIndex && <span>{footnoteIndex}</span>}
        <span
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(footnoteItem.Text + backIconLink),
          }}
        />
      </Text>
    </FootnoteStyledListItem>
  );
};

export default AudiFootnoteListItem;
